export const DRAWER_SIZES = {
    LARGE: 1366,
    MEDIUM: 1024,
    SMALL: 512,
    FULL: '100vw'
};